import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook, Linkedin, Music2, ChevronRight, MapPin, Phone, Mail, MessageCircle, Calendar } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0D0D0D] border-t-2 border-electric-yellow font-sans" data-id="element-132">
      {/* Top Section */}
      <div className="container mx-auto px-6 py-16" data-id="element-133">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-134">
          {/* Column 1: Brand */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="space-y-6" data-id="element-135">
            {/* Logo Placeholder */}
            <div className="flex items-center gap-2" data-id="element-136">
              <div className="w-10 h-10 bg-black border border-white/10 flex items-center justify-center rounded" data-id="element-137">
                <span className="text-electric-yellow font-bold text-xs" data-id="element-138">
                  DE
                </span>
              </div>
              <span className="text-white font-bold tracking-widest text-sm" data-id="element-139">
                DOCTOR ECOMMERCE
              </span>
            </div>

            <h3 className="text-electric-yellow font-heading font-bold text-xl italic" data-id="element-140">
              La cura para negocios estancados.
            </h3>

            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-141">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>

            <div className="flex items-center gap-4 pt-2" data-id="element-142">
              <a href="#" className="text-electric-yellow hover:text-white transition-colors" data-id="element-143">
                <Instagram className="w-6 h-6" data-id="element-144" />
              </a>
              <a href="#" className="text-electric-yellow hover:text-white transition-colors" data-id="element-145">
                <Facebook className="w-6 h-6" data-id="element-146" />
              </a>
              <a href="#" className="text-electric-yellow hover:text-white transition-colors" data-id="element-147">
                <Linkedin className="w-6 h-6" data-id="element-148" />
              </a>
              <a href="#" className="text-electric-yellow hover:text-white transition-colors" data-id="element-149">
                <Music2 className="w-6 h-6" data-id="element-150" />
              </a>
            </div>
          </motion.div>

          {/* Column 2: Servicios */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-151">
            <h4 className="text-electric-yellow font-bold uppercase tracking-wider mb-6" data-id="element-152">
              Servicios
            </h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-153">
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-154">
                Meta Ads · Google Ads · TikTok Ads · YouTube Ads
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-155">
                Email · SMS · Retargeting Automatizado
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-156">
                Automatización con IA para Ventas 24/7
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-157">
                Funnels Quirúrgicos por Industria
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-158">
                Blindaje Digital & Anti-Ban
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-159">
                PR Digital & Posicionamiento en Medios
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-160">
                CRM & Data Tracking Avanzado
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-161">
                Video Marketing IA · SEO · Branding
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-162">
                Gestión de Reputación · Google Maps
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-163">
                Diseño Web · Landing Pages · CRO
              </li>
            </ul>
          </motion.div>

          {/* Column 3: Recursos */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-164">
            <h4 className="text-electric-yellow font-bold uppercase tracking-wider mb-6" data-id="element-165">
              Recursos
            </h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-166">
              <li className="flex items-start gap-2 hover:text-white transition-colors cursor-pointer group" data-id="element-167">
                <ChevronRight className="w-4 h-4 mt-0.5 text-gray-500 group-hover:text-electric-yellow transition-colors" data-id="element-168" />
                <span data-id="element-169">Blog de Estrategia</span>
              </li>
              <li className="flex items-start gap-2 hover:text-white transition-colors cursor-pointer group" data-id="element-170">
                <ChevronRight className="w-4 h-4 mt-0.5 text-gray-500 group-hover:text-electric-yellow transition-colors" data-id="element-171" />
                <span data-id="element-172">Casos de Éxito</span>
              </li>
              <li className="flex items-start gap-2 hover:text-white transition-colors cursor-pointer group" data-id="element-173">
                <ChevronRight className="w-4 h-4 mt-0.5 text-gray-500 group-hover:text-electric-yellow transition-colors" data-id="element-174" />
                <span data-id="element-175">Política de Privacidad</span>
              </li>
              <li className="flex items-start gap-2 hover:text-white transition-colors cursor-pointer group" data-id="element-176">
                <ChevronRight className="w-4 h-4 mt-0.5 text-gray-500 group-hover:text-electric-yellow transition-colors" data-id="element-177" />
                <span data-id="element-178">Términos y Condiciones</span>
              </li>
            </ul>
          </motion.div>

          {/* Column 4: Contacto Directo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-179">
            <h4 className="text-electric-yellow font-bold uppercase tracking-wider mb-6" data-id="element-180">
              Contacto Directo
            </h4>
            <ul className="space-y-4 text-gray-300 text-sm mb-8" data-id="element-181">
              <li className="flex items-start gap-3" data-id="element-182">
                <MapPin className="w-5 h-5 text-electric-yellow shrink-0" data-id="element-183" />
                <span data-id="element-184">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-185">
                <Phone className="w-5 h-5 text-electric-yellow shrink-0" data-id="element-186" />
                <span data-id="element-187">402-872-0639</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-188">
                <Mail className="w-5 h-5 text-electric-yellow shrink-0" data-id="element-189" />
                <span data-id="element-190">doctor.ecommerceus@gmail.com</span>
              </li>
            </ul>

            <div className="space-y-3" data-id="element-191">
              <a href="https://wa.me/14028720639" target="_blank" rel="noopener noreferrer" className="w-full bg-emerald-glow hover:bg-emerald-400 text-black font-bold py-3 px-4 rounded flex items-center justify-center gap-2 transition-colors" data-id="element-192">
                <MessageCircle className="w-5 h-5" data-id="element-193" />
                Habla con un Especialista
              </a>
              <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="w-full bg-[#E5B842] hover:bg-electric-yellow text-black font-bold py-3 px-4 rounded flex items-center justify-center gap-2 transition-colors" data-id="element-194">
                <Calendar className="w-5 h-5" data-id="element-195" />
                RESERVAR DIAGNÓSTICO
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-[#080808] border-t border-white/10 py-12" data-id="element-196">
        <div className="container mx-auto px-6" data-id="element-197">
          <div className="flex flex-col lg:flex-row justify-between gap-12" data-id="element-198">
            {/* Partners */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2" data-id="element-199">
              <h5 className="text-gray-500 uppercase tracking-wider text-xs font-bold mb-6" data-id="element-200">
                Partners Certificados y Tecnología de Élite
              </h5>
              <div className="flex flex-wrap gap-3" data-id="element-201">
                {/* Placeholder Badges */}
                <div className="bg-white rounded px-4 py-2 flex items-center justify-center min-w-[80px] h-[40px]" data-id="element-202">
                  <span className="text-black text-[10px] font-bold" data-id="element-203">Meta</span>
                </div>
                <div className="bg-white rounded px-4 py-2 flex items-center justify-center min-w-[80px] h-[40px]" data-id="element-204">
                  <span className="text-black text-[10px] font-bold" data-id="element-205">
                    Google Ads
                  </span>
                </div>
                <div className="bg-white rounded px-4 py-2 flex items-center justify-center min-w-[80px] h-[40px]" data-id="element-206">
                  <span className="text-black text-[10px] font-bold" data-id="element-207">ISO</span>
                </div>
                <div className="bg-white rounded px-4 py-2 flex items-center justify-center min-w-[80px] h-[40px]" data-id="element-208">
                  <span className="text-black text-[10px] font-bold" data-id="element-209">
                    Certified
                  </span>
                </div>
                <div className="bg-white rounded px-4 py-2 flex items-center justify-center min-w-[80px] h-[40px]" data-id="element-210">
                  <span className="text-black text-[10px] font-bold" data-id="element-211">
                    Shopify
                  </span>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2" data-id="element-212">
              <h5 className="text-gray-500 uppercase tracking-wider text-xs font-bold mb-6" data-id="element-213">
                ¿Quieres que te contactemos?
              </h5>
              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-214">
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3" data-id="element-215">
                  <input type="text" placeholder="Tu Nombre" className="bg-transparent border border-white/20 rounded text-white placeholder-gray-500 py-2.5 px-4 focus:outline-none focus:border-electric-yellow transition-colors text-sm" data-id="element-216" />
                  <input type="email" placeholder="Tu Email" className="bg-transparent border border-white/20 rounded text-white placeholder-gray-500 py-2.5 px-4 focus:outline-none focus:border-electric-yellow transition-colors text-sm" data-id="element-217" />
                  <input type="tel" placeholder="Tu Teléfono" className="bg-transparent border border-white/20 rounded text-white placeholder-gray-500 py-2.5 px-4 focus:outline-none focus:border-electric-yellow transition-colors text-sm" data-id="element-218" />
                  <input type="text" placeholder="Nombre de tu Er" className="bg-transparent border border-white/20 rounded text-white placeholder-gray-500 py-2.5 px-4 focus:outline-none focus:border-electric-yellow transition-colors text-sm" data-id="element-219" />
                </div>
                <div data-id="element-220">
                  <button type="submit" className="bg-[#E5B842] hover:bg-electric-yellow text-black font-bold uppercase tracking-wider py-2.5 px-8 rounded transition-colors text-sm" data-id="element-221">
                    Enviar
                  </button>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </footer>;
}